//TODO adapt
export enum ERROR_CODES {
  COMPANYDATA_NOT_FOUND = 0,
  ORDER_NOT_FOUND = 1003,
  FRIENDLY_CAPTCHA_VALIDATION_ERROR = 1007,
  USER_DOMAIN_NOT_FOUND = 1018
}

export enum AuthErrorCodes {
  NO_COMPANY_DATA = 999,
  DOMAIN_USAGE = 998,
  USER_NOT_FOUND = 997,
  NO_APP_PERMISSION = 0
}
